import React from 'react';

import {
  ApplicationViewList,
  type FilterFields,
  type ApplicationViewListProps,
} from '../../../Application/components';

export const GSApplicationList: React.FunctionComponent = () => {
  const tableProps: ApplicationViewListProps['tableProps'] = {};

  const hiddenFilters: FilterFields[] = React.useMemo(() => ['gsAssignee'], []);
  const filterProps: ApplicationViewListProps['filterProps'] = {
    hiddenFilterFields: hiddenFilters,
    onlyPaidApplicationStatusList: false,
  };

  return (
    <ApplicationViewList tableProps={tableProps} filterProps={filterProps} />
  );
};
